import { render, staticRenderFns } from "./AdminTypeFilterList.vue?vue&type=template&id=a2121a98&"
import script from "./AdminTypeFilterList.vue?vue&type=script&lang=js&"
export * from "./AdminTypeFilterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports